import React from 'react';
import PropTypes from 'prop-types';
import { YT_PRIVACY_PRIVATE, YT_PRIVACY_UNLISTED, YT_PRIVACY_PUBLIC } from '../../constants';

import './scss/index.scss';

function PrivacySection({ privacyStatusValue, onChange }) {
  const onChangeValue = (event) => {
    onChange(event.target.value);
  };

  const isStatusPrivate = privacyStatusValue === YT_PRIVACY_PRIVATE;
  const isStatusUnlisted = privacyStatusValue === YT_PRIVACY_UNLISTED;
  const isStatusPublic = privacyStatusValue === YT_PRIVACY_PUBLIC;

  return (
    <fieldset
      className="visibility-details"
    >
      <legend>Visibility</legend>
      <div className="description">Who can see your video</div>
      <ul>
        <li>
          <input type="radio" value="private" id="private" name="visibility" onChange={onChangeValue} checked={isStatusPrivate} />
          { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
          <label htmlFor="private">
            <strong>Private</strong>
            <small>Only you can watch your video</small>
          </label>
        </li>
        <li>
          <input type="radio" value="unlisted" id="unlisted" name="visibility" onChange={onChangeValue} checked={isStatusUnlisted} />
          { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
          <label htmlFor="unlisted">
            <strong>Unlisted</strong>
            <small>Anyone with the video link can watch your video</small>
          </label>
        </li>
        <li>
          <input type="radio" value="public" id="public" name="visibility" onChange={onChangeValue} checked={isStatusPublic} />
          { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
          <label htmlFor="public">
            <strong>Public</strong>
            <small>Everyone can watch your video</small>
          </label>
        </li>
      </ul>
    </fieldset>
  );
}

PrivacySection.propTypes = {
  onChange: PropTypes.func.isRequired,
  privacyStatusValue: PropTypes.string.isRequired,
};

export default PrivacySection;
